exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".content-tool-1 {\n  fill: #fff;\n}\n\n.content-tool-2 {\n  fill: #72cac2;\n}\n\n.content-tool-3 {\n  fill: #fbe57f;\n}\n\n.content-tool-4 {\n  fill: #1e4e69;\n}\n\n.content-tool-5 {\n  opacity: 0.419;\n}", ""]);
